import styles from './styles.module.scss';

const PersonalizedTattoo = () => {
    return (
        <div className={styles.personalizedContainer}>
            <h1>Personalized Tattoo</h1>
        </div>
    );
}

export default PersonalizedTattoo;
